module.exports = __webpack_public_path__ + "static/media/dashboardBorrowerWhite.66e8da4b.svg";